module.exports = __webpack_public_path__ + "static/media/riabu-cash-flow.4c78047c.png";